import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { CheckboxComponent } from './inputs/checkbox/checkbox.component';
import { AlertComponent } from './alerts/alert/alert.component';
import { BadgesComponent } from './menus/badges/badges.component';
import { IconComponent } from './elements/icon/icon.component';
import { AvatarComponent } from './elements/avatar/avatar.component';
import { TagComponent } from './elements/tag/tag.component';
import { FormFieldComponent } from './inputs/form-field/form-field.component';
import { InputDirective } from './inputs/directives/input.directive';
import { AtLabel } from './inputs/directives/label.directive';
import { AtPrefix } from './inputs/directives/prefix.directive';
import { AtSuffix } from './inputs/directives/suffix.directive';
import { AtSupport } from './inputs/directives/support.directive';
import { RadioButtonComponent } from './inputs/radio-button/radio-button.component';
import { AtRadioLabel } from './inputs/directives/radio-label.directive';

@NgModule({
  declarations: [
    CheckboxComponent,
    AlertComponent,
    BadgesComponent,
    IconComponent,
    AvatarComponent,
    TagComponent,
    FormFieldComponent,
    InputDirective,
    AtLabel,
    AtPrefix,
    AtSuffix,
    AtSupport,
    RadioButtonComponent,
    AtRadioLabel
  ],
  exports: [
    CheckboxComponent,
    AlertComponent,
    BadgesComponent,
    IconComponent,
    AvatarComponent,
    TagComponent,
    FormFieldComponent,
    InputDirective,
    AtLabel,
    AtPrefix,
    AtSuffix,
    AtSupport,
    RadioButtonComponent,
    AtRadioLabel
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule
  ]
})
export class ComponentsModule { }
